import React, { createContext, useState,useRef, useEffect } from 'react';

const DataContext = createContext();

const DataProvider = ({ children }) => {
    const [activeLink, setActiveLink] = useState('/home');
    const [loading, setLoading] = useState(true);
    const [headData, setHeadData] = useState({goBack:false , link:null , title:null});
    const [headermsg, setheadermsg] = useState(null);
    const [Qarii, setQarii] = useState("ar.minshawi");
  const [playingVerse, setPlayingVerse] = useState(null);
  const pageRef = useRef(null);

    useEffect(() => {
      setTimeout(() => {
          setheadermsg(null);
      },2000);
    }, [headermsg]);
  

    return (
        <DataContext.Provider value={{
            activeLink,
            setActiveLink,
            loading,
            setLoading,
            headermsg, 
            setheadermsg,
            headData, 
            setHeadData,Qarii, setQarii,playingVerse, setPlayingVerse,
            pageRef
        }}>
            {children}
        </DataContext.Provider>
    );
};

export { DataContext, DataProvider };
